import { useContentFiltering } from "@hub/services/use-content-filtering";
import { ChevronIcon } from "@hub/ui/icons/chevron-icon";
import React from "react";
import styles from "./filters-button.module.css";

export const FiltersButton: React.FC = () => {
  const { openModal } = useContentFiltering();

  const openFilters = () => {
    openModal();
  };

  return (
    <div className={styles.filtersButton} onClick={openFilters}>
      <span className={styles.filtersButton__label}>Filters</span>
      <ChevronIcon />
    </div>
  );
};
